import { Building, Users, MapPin } from 'lucide-react';

export default function CompaniesTab({ companies }) {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-stone-900">Empresas</h1>
        <div className="text-sm text-stone-500">
          {companies.length} empresas registradas
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {companies.map((company, idx) => (
          <div key={company.name || idx} className="bg-white rounded-2xl border border-stone-200 p-6 hover:shadow-lg transition-shadow">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center">
                <Building className="w-6 h-6 text-emerald-700" />
              </div>
              <div>
                <h3 className="font-semibold text-stone-900">{company.name}</h3>
                <div className="flex items-center gap-1 text-sm text-stone-500">
                  <Users className="w-3 h-3" />
                  {company.users} usuarios
                </div>
              </div>
            </div>

            {company.floors?.length > 0 && (
              <div className="mb-3">
                <p className="text-xs text-stone-500 mb-1">Pisos</p>
                <div className="flex flex-wrap gap-1">
                  {company.floors.slice(0, 5).map((floor, i) => (
                    <span key={i} className="px-2 py-0.5 bg-stone-100 rounded text-xs text-stone-600">
                      {floor}
                    </span>
                  ))}
                  {company.floors.length > 5 && (
                    <span className="px-2 py-0.5 bg-stone-100 rounded text-xs text-stone-600">
                      +{company.floors.length - 5}
                    </span>
                  )}
                </div>
              </div>
            )}

            {company.work_areas?.length > 0 && (
              <div>
                <p className="text-xs text-stone-500 mb-1">Áreas</p>
                <div className="flex flex-wrap gap-1">
                  {company.work_areas.slice(0, 3).map((area, i) => (
                    <span key={i} className="px-2 py-0.5 bg-emerald-50 rounded text-xs text-emerald-700">
                      {area}
                    </span>
                  ))}
                  {company.work_areas.length > 3 && (
                    <span className="px-2 py-0.5 bg-emerald-50 rounded text-xs text-emerald-700">
                      +{company.work_areas.length - 3}
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {companies.length === 0 && (
        <div className="bg-white rounded-2xl border border-stone-200 p-12 text-center">
          <Building className="w-12 h-12 text-stone-300 mx-auto mb-4" />
          <p className="text-stone-500">No hay empresas registradas aún</p>
        </div>
      )}
    </div>
  );
}
